import React from 'react';
import ReportItem from './ReportItem';
import './ReportsList.css';

const ReportsList = ({ 
  reports, 
  selectedReportId, 
  onSelectReport 
}) => {
  if (!reports || reports.length === 0) {
    return (
      <div className="empty-state">
        <p>Nenhum relatório disponível</p>
        <span>Entre em contato com o administrador para configurar relatórios</span>
      </div>
    );
  }

  return (
    <div className="reports-list">
      {reports.map((report) => (
        <ReportItem
          key={report.id}
          report={report}
          isSelected={selectedReportId === report.id}
          onSelect={onSelectReport}
        />
      ))}
    </div>
  );
};

export default ReportsList;
